import HeroBackground from './HeroBackground';

export default HeroBackground;
